// eslint-disable-next-line no-unused-vars,no-undef
const pluginInstance = new PearsonVideo({});
